<template>
  <Content :button-create-show="true">
    <template #body>
      <Table
        :columns="columns"
        :options="columnsOptions"
        :method-fetch-data="methods.fetchData"
      >
        <template #controls="{ row }">
          <div class="button-group-vertical">
            <router-link :to="`edit/${row.id}`">
              <el-button icon="el-icon-edit" size="mini">
                Редактировать
              </el-button>
            </router-link>
            <router-link :to="`edit/${row.id}/hidden-sections`">
              <el-button icon="el-icon-view" size="mini">
                Скрытые разделы
              </el-button>
            </router-link>
          </div>
        </template>
      </Table>
    </template>
  </Content>
</template>

<script>
import Table from "@/components/Table";
import Content from "@/layout/Content";

import { getDigests as fetchData } from "@/api/digest";

const columnsOptions = {
  sortable: false,
  itemsName: "items",
  controls: { width: 180 },
  editable: true,
  id: "id",
  search_list: [
    {
      label: "Поиск по ID",
      name: "digest_id",
      strong: true,
    },
    {
      label: "Поиск по названию",
      name: "name",
    },
  ],
};

const columns = [
  {
    prop: "id",
    label: "ID",
    width: 50,
  },
  {
    prop: "name",
    label: "Название",
  },
  {
    prop: "start_date",
    label: "Дата начала",
    type: "date",
  },
];

export default {
  components: {
    Content,
    Table,
  },
  data() {
    return {
      columnsOptions: columnsOptions,
      columns: columns,
      methods: {
        fetchData,
      },
    };
  },
};
</script>
